import React from "react";
import classNames from "classnames";
import * as bd from "../index";
import SvgDelete from "../icons/Delete";
import SvgClose from "../icons/Close";

interface ChipProps {
    label?: any;
    className?: string;
    deleteColor?: "" | "inherit" | "default" | "primary" | "secondary";
    deleteIcon?: any;
    size?: "" | "sm" | "md";
    onClick?: () => void;
    onDelete?: () => void;
    [x: string]: any;
}

export const Chip = ({ icon, label, outline, className, size, deleteColor, deleteIcon, onClick, onDelete, ...props }: ChipProps) => {
    //if (!color) color = "primary";

    return (
        <div
            className={classNames(className, "bd-chip-root", {
                "bd-chip-filled": !outline,
                "bd-chip-outlined": outline,
                "bd-chip-sm": size === "sm",
                "bd-chip-md": size === "md",
                "cur-pointer": onClick,
                "cur-default": !onClick,
            })}
            {...props}
            onClick={onClick}
        >
            {icon && <span className={classNames("bd-chip-icon", { "m-s-1": size !== "md" && size !== "sm" })}>{icon}</span>}

            <span className="bd-chip">{label}</span>
            {onDelete && (
                <bd.Button
                    type="button"
                    variant="icon"
                    color={deleteColor}
                    size="sm"
                    className={classNames("bd-chip-delete m-s-n2", { "m-e-1": size !== "md" && size !== "sm" })}
                    onClick={(ev) => {
                        if (onDelete) onDelete();
                        ev.stopPropagation();
                    }}
                >
                    {deleteIcon ?? <SvgClose />}
                </bd.Button>
            )}
        </div>
    );
};
